import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { FaWhatsapp } from 'react-icons/fa';
import { LuQrCode, LuX } from 'react-icons/lu';
import logger from '../../utils/logging/logger';
import {
  CourseJoinRow, CourseJoinName, CourseJoinMeta, CourseJoinText, JoinActions, JoinButton, QrToggle,
  QrPanel, QrClose, QrBox, QrText, QrOpenLink
} from './WhatsAppJoin.styles';

// One course's row in the "Join your course WhatsApp group" card: the course, a Join button, and a
// "QR code" button that opens a panel with a QR code of the same link (scan it with a phone camera
// when this page is open on a computer).
export default function WhatsAppJoinRow({ course, link, meta }) {
  const [showQr, setShowQr] = useState(false);
  const [qrImage, setQrImage] = useState(null);
  const panelId = `whatsapp-qr-${course.id}`;

  useEffect(() => {
    if (!showQr || qrImage) return undefined;
    let cancelled = false;
    QRCode.toDataURL(link, { width: 240, margin: 1, errorCorrectionLevel: 'M', color: { dark: '#000000', light: '#F3EEE3' } })
      .then((url) => { if (!cancelled) setQrImage(url); })
      .catch((error) => logger.error('Could not create the WhatsApp QR code', { error }));
    return () => { cancelled = true; };
  }, [showQr, qrImage, link]);

  return (
    <>
      <CourseJoinRow>
        <CourseJoinText>
          <CourseJoinName>{course.name}</CourseJoinName>
          {meta && <CourseJoinMeta>{meta}</CourseJoinMeta>}
        </CourseJoinText>
        <JoinActions>
          <QrToggle
            type="button"
            onClick={() => setShowQr((open) => !open)}
            aria-expanded={showQr}
            aria-controls={panelId}
            aria-label={`${showQr ? 'Hide' : 'Show'} QR code for ${course.name}`}
          >
            <LuQrCode size={16} aria-hidden="true" />
            QR Code
          </QrToggle>
          <JoinButton
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Join the WhatsApp group for ${course.name}`}
          >
            <FaWhatsapp size={16} aria-hidden="true" /> Join
          </JoinButton>
        </JoinActions>
      </CourseJoinRow>
      {showQr && (
        <QrPanel id={panelId}>
          <QrClose type="button" onClick={() => setShowQr(false)} aria-label={`Close QR code for ${course.name}`}>
            <LuX size={16} aria-hidden="true" />
          </QrClose>
          <QrBox>
            {qrImage
              ? <img src={qrImage} alt={`QR code to join the WhatsApp group for ${course.name}`} width="112" height="112" />
              : <span>QR code…</span>}
          </QrBox>
          <QrText>
            <p>Scan with your phone camera to open the group in WhatsApp.</p>
            <QrOpenLink href={link} target="_blank" rel="noopener noreferrer">Or open on this device</QrOpenLink>
          </QrText>
        </QrPanel>
      )}
    </>
  );
}
